import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "@/lib/utils"

function Popover({
  ...props
}) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({
  ...props
}) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "tw:bg-popover tw:text-popover-foreground tw:data-[state=open]:tw:animate-in tw:data-[state=closed]:tw:animate-out tw:data-[state=closed]:tw:fade-out-0 tw:data-[state=open]:tw:fade-in-0 tw:data-[state=closed]:tw:zoom-out-95 tw:data-[state=open]:tw:zoom-in-95 tw:data-[side=bottom]:tw:slide-in-from-top-2 tw:data-[side=left]:tw:slide-in-from-right-2 tw:data-[side=right]:tw:slide-in-from-left-2 tw:data-[side=top]:tw:slide-in-from-bottom-2 tw:z-50 tw:w-72 tw:origin-(--radix-popover-content-transform-origin) tw:rounded-xs tw:border tw:border-gray-300 tw:p-4 tw:shadow-md tw:outline-hidden",
          className
        )}
        {...props} />
    </PopoverPrimitive.Portal>
  );
}

function PopoverAnchor({
  ...props
}) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
